import React, {PureComponent} from 'react';
import {Collapse} from "@mui/material";
import useWithStore from "@/Hooks/useWithStore";
import Svg from "@/Components/Svg";

class FaqItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {}
        // Создаем динамические состояния для элементов
        const {questionData = []} = this.props;

        questionData.forEach((el) => {
            try {
                this.state[`question_${el.id}`] = false;
            } catch (e) {
                console.log('e', e);
            }
        });
    }

    // Меняем динамические состояния для вакансий
    toggleReviews(id) {
        this.setState({[`question_${id}`]: !this.state[`question_${id}`]});
    }

    render() {
        const {questionData = []} = this.props;

        const element = questionData.map((el) => {
            return <div key={el.id} className={`faq__item ${this.state[`question_${el.id}`] ? 'active' : ''}`}>
                <div className={`faq__title-wrapper`}
                     onClick={() => this.toggleReviews(el.id)}>
                    <p className={`faq__title ${this.state[`question_${el.id}`] ? 'active' : ''}`}>
                        {el.title}
                    </p>
                    <div className={`faq__icon`}>
                        {this.state[`question_${el.id}`] ?
                            <Svg id={`keyboardArrowDownOutlinedIcon`} className={`faq__arrow faq__arrow_up`} />
                            :
                            <Svg id={`keyboardArrowDownOutlinedIcon`} className={`faq__arrow faq__arrow_down`} />
                        }
                    </div>
                </div>
                <Collapse in={this.state[`question_${el.id}`]}>
                    <p className={`faq__description`}>
                        {el.description}
                    </p>
                </Collapse>
            </div>
        })
        return <>
            {element}
        </>
    }
}

export default useWithStore(FaqItem);
